module.exports = __webpack_public_path__ + "img/sld_ch_13_t1_green.da3e1138.svg";